module.exports = __webpack_public_path__ + "static/media/welcomeBg_responsive.352e9f6c.jpg";